// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PassengerList__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/PassengerList.scss
 ** module id = 874
 ** module chunks = 1
 **/